import autoload from "./autoload";
import initDom from "./mixins/init_dom";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import project from "./mixins/project";
import colorFilter from "./mixins/color_filter";
import InfiniteLoading from "vue-infinite-loading";
import Search from "./components/global/Search.vue";
import ProjectUploadModal from "./components/modals/ProjectUploadModal.vue";

autoload();

window.app = new Vue({
  el: "#vue-gallery",

  mixins: [initDom, colorFilter, auth, cart, project],

  components: {
    InfiniteLoading,
    Search,
    ProjectUploadModal,
  },

  data() {
    return {
      waitingForLogIn: false, // This tells whether we are supposed to open the upload popup after login
      /**
       * @todo API: Get this from API
       */
      topSearches: [
        "Automotive",
        "Electronics",
        "Lifestyle",
        "S.H.O.T",
        "Sports and Fitness",
        "Golf",
        "Fishing",
      ],
      filterProjects: false,
      projects: window._PR?.projects?.data || [],
      pagination: {},
      currentTab: "",
      orderSelected: "",
      queryParams: {},
      selectedTopSearch: {},
      message: window._PR?.message || "",
      hostname: window.location.hostname,
      selectedTags: [],
      showFooter: window._PR?.showFooter || false,
      bookmarked: window._PR?.bookmarked || false,
      owned: window._PR?.owned || false,
    };
  },

  computed: {
    userHasMasCustomerNo() {
      if (this.$root.isLoggedIn) {
        if (this.$root.me.customer_id !== null) {
          return true;
        }
      }

      return false;
    }
  },

  created() {
    if (window.location.href.includes("?tab=newest")) {
      $("#newest").addClass("active");
    } else if (window.location.href.includes("?tab=trending")) {
      $("#trending").addClass("active");
    }
  },

  mounted() {
    let vm = this;

    vm.hostname = window.location.hostname;
    vm.showFooter = false;

    $(window).on("resize load", function () {
      $(window).scroll(function () {
        if ($(window).scrollTop() >= 310) {
          $(".gallery-full .back-to-top").css("display", "inline");
        } else {
          $(".gallery-full .back-to-top").css("display", "none");
        }
      });
    });

    $(window).trigger("resize");
  },

  watch: {
    isLoggedIn() {
      // If user was trying to upload a project without login and now has logged in.
      if (this.waitingForLogIn && this.isLoggedIn) {
        this.waitingForLogIn = false;

        $("#projectUpload").modal("show");

        setTimeout(function () {
          $(document.body).addClass("modal-open");
        }, 1000);
      }
    },
  },

  methods: {
    /**
     * @function loadGalleryProjects
     * @description sets data to be used here in this file from the Search.vue component
     */
    loadGalleryProjects(queryParamData, tags) {
      this.selectedTags = tags;
      this.queryParams = queryParamData;
      this.queryParams.page = 1;
      this.queryParams.limit = 20;
      this.resetLoading();
    },

    openLoginModal() {
      $("#logInLink").click();
    },

    openUploadModal(e) {
      let userProfileData = this.me;

      let isLocked =
        userProfileData != null &&
        userProfileData.lock_reason &&
        Object.keys(userProfileData.lock_reason).length > 0;

      if (this.isLoggedIn) {
        if (isLocked) {
          $("#informationModal").modal("show");
        } else {
          $("#projectUpload").modal("show");
        }
      } else {
        $("#logInLink").click();
        this.waitingForLogIn = true;
      }
    },

    renderProjects($state) {
      const projectUrl = `/api/proxify/domains/cerakote/gallery-search`;

      this.queryParams.orderdir = "desc";

      const fields = [
        "id",
        "url",
        "is_bookmarked",
        "featured_image_url",
        "name",
        "applicator.company_name",
        "applicator.customer_id",
        "authored_by.display_name",
      ].join(",");

      this.queryParams.fields = fields;

      axios
        .get(projectUrl, {
          params: this.queryParams,
        })
        .then(({ data: response }) => {
          if (!response.data.length) {
            $state.complete();
            this.showFooter = true;
          }

          if (response.pagination.page === 1) {
            if (!response.data.length) {
              this.message = "Sorry, No Matching Gallery Projects";
              this.showFooter = true;
            }

            this.projects = response.data.map((project) => {
              if (this.queryParams.bookmarked) {
                project.is_bookmarked = true;
              }
              if (project.featured_image_url) {
                if (project.featured_image_url.indexOf("?") > -1) {
                  project.featured_image_url += "&";
                } else {
                  project.featured_image_url += "?"; // null?
                }
              }

              return project;
            });
          } else {
            const updatedProjects = response.data.map((project) => {
              if (this.queryParams.bookmarked) {
                project.is_bookmarked = true;
              }
              if (project.featured_image_url) {
                if (project.featured_image_url.indexOf("?") > -1) {
                  project.featured_image_url += "&";
                } else {
                  project.featured_image_url += "?";
                }
              }

              return project;
            });

            this.projects.push(...updatedProjects);
          }

          this.queryParams.page = response.pagination.page + 1;
          this.queryParams.limit = response.pagination.items_per_page;

          $state.loaded();

          // toggle front end rendering
          if (!this.filterProjects) {
            this.filterProjects = true;
          }
        })
        .catch((response) => {
          console.log(response);
          $state.complete();
          this.showFooter = true;
        });
    },

    /**
     * @function selectTopSearch
     * @description Filters products based on top search term user selected
     * @todo API: filter products based on search term
     * @param searchTag
     */
    selectTopSearch(searchTag) {
      const dataObj = {
        id: searchTag,
        code: `cera_${searchTag?.toLowerCase()}`,
        type: "hashtag",
        label: searchTag,
        search: searchTag,
      };

      if (this.selectedTopSearch != null) {
        if (this.selectedTopSearch.id !== searchTag) {
          this.selectedTags.push(dataObj);
          this.resetLoading();
        }
      } else {
        this.selectedTags.push(dataObj);
        this.resetLoading();
      }
    },

    changeTab(tab) {
      this.currentTab = tab;

      switch (tab) {
        case "newest":
          this.$set(this.queryParams, "orderby", "created_at");
          this.orderSelected = "newest";
          break;
        case "trending":
          this.$set(this.queryParams, "orderby", "trending_index");
          this.orderSelected = "trending";
          break;
        case "color":
          this.$set(this.queryParams, "cids", "");
          break;
        case "top-searches":
          break;
      }

      this.resetLoading();
    },

    // Bookmark toggling logic is handled in the project.js mixin

    resetLoading() {
      // Turn on front end rendering
      if (!this.filterProjects) {
        this.filterProjects = true;
      }

      this.showFooter = false;
      this.message = "";
      this.projects = [];
      this.queryParams.page = 1;
      this.$nextTick(() => {
        //  no matter if all filters are off just reset the loader
        this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
      });
    },
  },
});
